<template>
  <div
    v-if="prop.id !== null"
    class="profile-property__row">
    <div class="profile-property__name">
      {{ prop.name }}
    </div>
    <div class="profile-property__input-wrapper">
      <component
        :is="getComponentName(prop.code)"
        :property="prop"
        :validator="getValidatorByCode(prop.code)"
        @onChangeValidation="e => $emit('onChangeValidation', e)"
        @onChangeValue="onChangeValue"/>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import isEmpty from 'lodash/isEmpty'
  import Common from './Common'
  import Inn from './Inn'
  import Phone from './Phone'
  import Location from './Location'

  export default {
    name: 'ProfileProperty',
    components: {
      Common,
      Inn,
      Phone,
      Location
    },
    props: {
      prop: {
        type: Object,
        default: () => ({
          id: null
        })
      }
    },
    methods: {
      ...mapMutations('profile', [
        'setProfilePropValueByCode'
      ]),
      getComponentName: function (code) {
        if (code === 'COMPANY' ||
          code === 'COMPANY_ADR' ||
          code === 'COMPANY_FACT_ADR' ||
          code === 'COMPANY_DOCUMENTS_ADR' ||
          code === 'CONTACT_PERSON' ||
          code === 'KPP' ||
          code === 'EMAIL' ||
          code === 'LAST_NAME' ||
          code === 'SECOND_NAME' ||
          code === 'NAME') {
          return 'Common'
        } else if (code === 'INN') {
          return 'Inn'
        } else if (code === 'PHONE') {
          return 'Phone'
        } else if (code === 'LOCATION') {
          return 'Location'
        }
        return null
      },
      getValidatorByCode: function (code) {
        if (code === 'COMPANY' ||
          code === 'COMPANY_ADR' ||
          code === 'COMPANY_FACT_ADR' ||
          code === 'COMPANY_DOCUMENTS_ADR' ||
          code === 'LAST_NAME' ||
          code === 'NAME') {
          return val => !isEmpty(val) && val.length > 2
        } else if (code === 'EMAIL') {
          return val => isEmpty(val) || /.+@.+\..+/i.test(val)
        } else if (code === 'PHONE') {
          return val => isEmpty(val) || val.replace('_', '').length === 18
        }

        return () => true
      },
      onChangeValue: function (payload) {
        this.setProfilePropValueByCode(payload)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/Inputs/ProfileProperty.vue